import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFyaiConfig } from "@/hooks/useFyaiConfig";
import { fyaiLogo } from "@/mocks/fyai-data";

const navItems = [
  { label: "功能特色", href: "#features" },
  { label: "AI角色", href: "#characters" },
  { label: "软件截图", href: "#screenshots" },
  { label: "常见问题", href: "#faq" },
];

export default function FyaiHeader() {
  const config = useFyaiConfig();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <header className="fyai-header-gpu sticky top-0 z-50 w-full border-b border-background-200 bg-background-50">
      <div className="flex h-16 w-full items-center justify-between px-4 md:h-20 md:px-6">
        <a
          href={config.officialUrl}
          className="flex items-center gap-2.5 cursor-pointer md:gap-3"
          aria-label="风月AI官网，域名 fengyueaiapp.net"
          title="风月AI官网"
        >
          <span className="flex h-10 w-10 items-center justify-center overflow-hidden rounded-lg md:h-11 md:w-11">
            <img src={fyaiLogo} alt="风月AIlogo" title="风月AI官网下载" className="h-full w-full object-cover" />
          </span>
          <span className="flex flex-col leading-tight">
            <span className="font-heading text-base font-bold text-foreground-950 md:text-lg">风月AI</span>
            <span className="text-[11px] tracking-wide text-foreground-500 md:text-xs">{config.domain}</span>
          </span>
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            onClick={() => navigate("/download")}
            className="hidden cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            <i className="ri-download-2-line" />
            立即下载
          </button>
          <button
            onClick={() => setOpen((v) => !v)}
            className="inline-flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 md:hidden"
            aria-label="打开菜单"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-2 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100"
              >
                {item.label}
              </a>
            ))}
            <button
              onClick={() => {
                setOpen(false);
                navigate("/download");
              }}
              className="mt-2 inline-flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50"
            >
              <i className="ri-download-2-line" />
              立即下载
            </button>
          </nav>
        </div>
      )}
    </header>
  );
}